<template>
  <div
    v-loading="loading"
    class="CaliberLibrary"
  >
    <div class="header">
      <div class="header-content"><el-input
          style="width:660px;"
          placeholder="请输入内容"
          v-model="params.keyword"
          @change="getList"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
          ></el-button>
        </el-input></div>

    </div>
    <div class="bg">
      <CaliberLibraryTypeSelect
        title="领域类型："
        :opts="industryOpt"
        :checked.sync="params.industryList"
        @update:checked="getList"
        :openExpand="true"
      ></CaliberLibraryTypeSelect>
      <CaliberLibraryTypeSelect
        title="危机类型："
        :opts="categoryOpt"
        :checked.sync="params.categoryList"
        @update:checked="getList"
      ></CaliberLibraryTypeSelect>
      <CaliberLibrarySelect
        title="介入时间："
        :opts="timeOpts"
        :checked.sync="params.timeType"
        @update:checked="getList"
      ></CaliberLibrarySelect>
    </div>

    <CaliberLibraryList :list="list" />
  </div>
</template>

<script>
import client from '../server/server'
import DataNull from '../components/DataNull'
import CaliberLibraryTypeSelect from './CaliberLibraryTypeSelect.vue'
import CaliberLibrarySelect from './CaliberLibrarySelect.vue'
import CaliberLibraryList from './CaliberLibraryList.vue'

export default {
  name: 'CaliberLibrary',
  components: {
    DataNull,
    CaliberLibraryTypeSelect,
    CaliberLibrarySelect,
    CaliberLibraryList
  },
  data () {
    return {
      params: {
        keyword: '',
        page: 1,
        size: 100,
        categoryList: '全部',
        industryList: '全部',
        timeType: '全部'
      },
      timeOpts: [
        {
          name: '全部',
          value: '全部'
        }, {
          name: '24小时内',
          value: '24小时内'
        }, {
          name: '48小时内',
          value: '48小时内'
        }, {
          name: '其他',
          value: '其他'
        }
      ],
      list: [],
      loading: false
    }
  },
  mounted () {
    this.getList()
  },
  computed: {
    focusIndustryList () {
      return this.$store.state.user.userinfo.focusIndustryList
    },
    focusCategoryList () {
      return this.$store.state.user.userinfo.focusCategoryList
    },
    industryOpt () {
      return this.focusIndustryList.map(t => {
        return {
          name: t,
          value: t
        }
      })
    },
    categoryOpt () {
      return this.focusCategoryList.map(t => {
        return {
          name: t,
          value: t
        }
      })
    }
  },
  watch: {
  },
  methods: {
    updateTime () {
      if (this.time) {
        this.params.startTime = this.time[0]
        this.params.endTime = this.time[1]
      }
      this.getList()
    },
    getList () {
      this.loading = true
      client.GetVenationList(this.params)
        .then(res => {
          if (res.success) {
            const { list } = res.data
            this.list = list
          }
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.CaliberLibrary {
  padding-top: 92px;
  .header {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 92px;
    background-color: #fff;
    padding-top: 26px;
    .header-content {
      width: 1240px;
      margin: 0 auto;
    }
  }
  .bg {
    margin-top: 30px;
    background-color: #fff;
    border-radius: 4px;
    padding-left: 40px;
    padding-right: 30px;
    padding-top: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/CaliberLibrary/CaliberLibrary.vue